<template>

    <div class="main">
        <form-aluno call="index" :paramId="$route.params.id" v-on:onSubmitFormAluno="onSubmitFormAluno"></form-aluno>
    </div>
    
</template>
<script>

import formAluno from "./form"


export default {
    methods:{

        onSubmitFormAluno(){

            this.$router.push('/admin/aluno');  
        }
    },
    components:{ formAluno }
}
</script>
